import React from "react";

export default function PageHeader({ eyebrow, title, lead, actions, children }) {
    return (
        <header className="px-8 md:px-12 pt-10 pb-6 border-b hairline" data-testid="page-header">
            <div className="max-w-6xl">
                {eyebrow && <div className="label-eyebrow mb-3">{eyebrow}</div>}
                <div className="flex items-end justify-between gap-6 flex-wrap">
                    <h1 className="font-display text-4xl md:text-5xl tracking-tight leading-[1.05] text-[var(--ink)]" data-testid="page-title">
                        {title}
                    </h1>
                    {actions && <div className="flex items-center gap-3">{actions}</div>}
                </div>
                {lead && (
                    <p className="mt-4 text-[var(--ink-2)] max-w-3xl leading-relaxed">{lead}</p>
                )}
                {children}
            </div>
        </header>
    );
}
